interface WordmarkProps {
  short?: boolean;
  size?: "sm" | "md" | "lg";
}

// Heights of the Binogi SVG logo at each size. The SVG's intrinsic aspect
// ratio (71×34 ≈ 2.09:1) is preserved by setting only the height.
const LOGO_HEIGHT_PX: Record<NonNullable<WordmarkProps["size"]>, number> = {
  sm: 22,
  md: 28,
  lg: 40,
};

const TEXT_CLASS: Record<NonNullable<WordmarkProps["size"]>, string> = {
  sm: "text-base",
  md: "text-lg",
  lg: "text-2xl",
};

export default function Wordmark({ short = false, size = "md" }: WordmarkProps) {
  const h = LOGO_HEIGHT_PX[size];
  return (
    <div className="inline-flex items-center gap-2.5 select-none">
      {!short && (
        <img
          src="/binogi-logo.svg"
          alt="Binogi"
          width={h * (71 / 34)}
          height={h}
          style={{ height: h, width: "auto" }}
          draggable={false}
        />
      )}
      <span className={`font-bold tracking-tight text-white ${TEXT_CLASS[size]}`}>
        Buzz
      </span>
    </div>
  );
}
